module.exports = __webpack_public_path__ + "static/media/microsoft.3604578a.webp";